import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import DrawerCustom from "../../components/DrawerCustom";
import { dataUtil, usage_type } from "../../wsclient/crmservices/dataUtil";
import CustomTypo from "../../components/CustomTypo";
import { getLogo } from "../../utils/common";
import { GoogleMapIcon } from "../../components/icons";

const useStyles = makeStyles((theme) => ({
    container: {
        // padding: theme.spacing(4),
    },
    merchant: {
        justifyItems: 'center',
        alignItems: 'center',
        padding: theme.spacing(2),
    },
    merchant_image: {
       textAlign: 'center',
    },
    offer: {
        justifyItems: 'center',
        alignItems: 'center',
        padding: theme.spacing(2),
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.background.transparent,
            opacity: 0.7,
        }
    },
    image: {
        width: 100,
        height: 100,
        objectFit: 'contain',
    },
    item_image: {
        textAlign: 'center',
    },
    offer_name: {
        paddingLeft: theme.spacing(3),
    },
    btn_directions: {
        color: theme.palette.background.primary,
        cursor: 'pointer',
        marginTop: theme.spacing(2),
    },
    google_map: {
        cursor: 'pointer',
    },
}));

export default function LocationOffersView(props) {
    const { open, onClose, offers, merchant, onDirection } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    console.log("merchant info ===", merchant);

    var distance = merchant.location && merchant.location.distance ? merchant.location.distance.toFixed(2) : null;
    var address = "";
    if (merchant.location) {
        if (merchant.location.address_line_1) {
            address = address + merchant.location.address_line_1;
        }
        if (merchant.location.address_line_2) {
            address = address + ", " + merchant.location.address_line_2;
        }
        if (merchant.location.town_city) {
            address = address + ", " + merchant.location.town_city;
        }
    }
    var phone_number = null;
    var email = null;
    if (merchant.contact_info) {
        merchant.contact_info.forEach((item) => {
            if (merchant.type === "PHONE") {
                phone_number = merchant.value;
            } else if (merchant.type === "EMAIL") {
                email = merchant.value;
            }
        });
    }
    var covertToKM = 0;
    if (distance) covertToKM = distance * 1.6;
    if (covertToKM) covertToKM = covertToKM.toFixed(2);

    return (
        <>
            <DrawerCustom
                open={open}
                onClose={() => onClose()}
                // fullScreen
                title={merchant.name ? merchant.name : ''}
                children={
                    <Grid item xs={12} className={classes.container}>
                        <Grid item xs={12} container className={classes.merchant}>
                            <Grid item xs={3}>
                                <Grid item xs={12} className={classes.merchant_image}>
                                    <MerchantItemImage
                                        classes={classes}
                                        t={t}
                                        image={dataUtil.getImageByUsageTypePortal(
                                            merchant.creatives,
                                            usage_type.offer_detail_merchant
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={7}>
                                {address ? (
                                    <Grid xs={12} item>
                                        <CustomTypo light>
                                            {address}
                                        </CustomTypo>
                                    </Grid>
                                ) : null}
                                {phone_number ? (
                                    <CustomTypo light>
                                        {phone_number}
                                    </CustomTypo>
                                ) : null}
                                {email ? (
                                    <CustomTypo light>
                                        {email}
                                    </CustomTypo>
                                ) : null}
                                {distance ? (
                                    <CustomTypo light>
                                        {covertToKM} km ({distance} mi)
                                    </CustomTypo>
                                ) : null}
                            </Grid>
                            <Grid item xs={2} className={classes.google_map} onClick={() => onDirection(merchant.location)} title={t('directions')}>
                                {/* <GoogleMapIcon /> */}
                                <CustomTypo className={classes.btn_directions} onClick={()=> onDirection(merchant.location)}>{t('directions')}</CustomTypo>
                            </Grid>
                            {/* <Grid
                                item
                                xs={1}
                                container
                                justify="flex-end"
                                onClick={() => onDirection(merchant.location)}
                                className={classes.google_map}
                            >
                                <GoogleMapIcon />
                            </Grid> */}
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTypo light variant="h6" mg_top_xl>{t('text_title_to_be_replace')}</CustomTypo>
                            {offers && offers.length > 0 && offers.map((item, index) => {
                                return (
                                    <Grid item xs={12} className={classes.offer_item} key={index}>
                                        <OfferItem 
                                            item={item}
                                            t={t}
                                            classes={classes}
                                            onSelectOffer={props.onSelectOffer}
                                        />
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Grid>
                }
            />
        </>
    );
}

function MerchantItemImage(props) {
    const { classes, image } = props;

    if (image && image.url) {
        return <img src={image.url} className={classes.image} />;
    } else {
        return (
            <img className={classes.image} src={getLogo()}></img>
        );
    }
}

function OfferItem(props){
    const { item, classes, t, onSelectOffer } = props;
    // console.log("AAAA getLogo():", getLogo());

    return(
        <Grid item xs={12} container className={classes.offer} onClick={() => onSelectOffer(item)}>
            <Grid item xs={3} className={classes.item_image}>
                <OfferItemImage 
                    image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.offer_detail)}
                    classes={classes}
                    t={t}
                />
            </Grid>
            <Grid item xs={9}>
                <CustomTypo light className={classes.offer_name}>{item.name}</CustomTypo>
            </Grid>
        </Grid>
    );
}

function OfferItemImage(props) {
    const { classes, image } = props;

    if (image && image.url) {
        return <img src={image.url} className={classes.image} />;
    } else {
        return (
            <div></div>
        );
    }
}
